// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";

// Data
import propertyData from "pages/Home/sections/data/propertyData";

function PropertyHighlights() {
  const { guests, bedrooms, bathrooms, rating } = propertyData.highlights;

  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
          <Grid item xs={6} md={3}>
            <DefaultCounterCard
              count={guests}
              suffix="+"
              title="Guests"
              description="Sleeps comfortably"
            />
          </Grid>
          <Grid item xs={6} md={3} display={{ xs: "block", md: "flex" }}>
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, mx: 0 }} />
            <DefaultCounterCard count={bedrooms} title="Bedrooms" description="Spacious rooms" />
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, ml: 0 }} />
          </Grid>
          <Grid item xs={6} md={3} display={{ xs: "block", md: "flex" }}>
            <DefaultCounterCard
              count={bathrooms}
              decimals={1}
              title="Bathrooms"
              description="Fully equipped"
            />
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, ml: 0 }} />
          </Grid>
          <Grid item xs={6} md={3}>
            <DefaultCounterCard
              count={rating}
              decimals={2}
              suffix="/5"
              title="Guest Rating"
              description={`${propertyData.highlights.reviews}+ reviews`}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default PropertyHighlights;
